import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const ssoSession = localStorage.getItem('sso-session');

  if (ssoSession && ssoSession !== 'undefined' && ssoSession !== '') {
    return true;
  } else {
    router.navigate(['/']);
    return false;
  }
};
